import React, { useState } from "react";
import "../styles/AboutPage.css";

/* =========================
   IMAGE IMPORTS
========================= */
import HeroImage from "../assets/hero4.jpeg";

import Mythili from "../assets/Mythili_website_photo.jpeg";
import Shailendra from "../assets/Shailendra_website_photo.jpeg";
import Karl from "../assets/Karl_website_photo.jpeg";
import Senthil from "../assets/Senthil_website_photo.jpeg";
import Rathinam from "../assets/rathinamam.jpg";
import Poornima from "../assets/Poornima_website_photo.jpeg";
import Manjamadevi from "../assets/Manjamadevi_website_photo.jpeg";
import Aparna from "../assets/Aparna_website_photo.jpeg";
import Premchand from "../assets/Prem_website_photo.jpeg";


/* =========================
   ABOUT PAGE
========================= */

export default function AboutPage({ heroImage = HeroImage, team = [] }) {
  const [activeMember, setActiveMember] = useState(null);

  const TEAM_DATA = team.length
    ? team
    : [
        {
          name: "R Mythili",
          role: "Founder",
          photo: Mythili,
          bio: `With nearly 15 years of expertise in the education industry, Mythili is a seasoned professional in software courses and curriculum development. Holding a Master’s degree, she has successfully pioneered future-focused software programs tailored for both college students and corporate professionals. Mythili excels in designing practical, outcome-driven courses that meet the evolving needs of the corporate sector, ensuring learners are equipped with the latest industry-relevant skills.”`
        },
        {
          name: "Dr. Shailendra Naidu",
          role: "Founder",
          photo: Shailendra,
          bio: "Dr. Shailendra Naidu, an alumnus of London Business School, is a seasoned leader with over 25 years of experience in digital money, telecom, and education. He has held key roles globally, driving transformational change, scaling operations, and leading successful turnarounds in East Africa and Asia. In telecom, he played a pivotal role in expanding digital infrastructure in emerging markets, while his expertise in digital finance helped bridge the digital divide. As the founder of Sprout, an education company focused on teaching 21st-century skills, Dr. Shailendra is passionate about empowering the next generation with the 4Cs – Creativity, Critical Thinking, Communication, and Collaboration. He is an advocate of purpose-driven leadership, balancing profit with social good."
        },
        {
          name: "Karl Eckerstorfer",
          role: "Founder",
          photo: Karl,
          bio: "London Business School Alumni with over 25 years of experience in Investment Banking and Tourism Sectors. Karl is based out of Europe and as an investment banker handled deals sizes upwards of 1.6 billion Euro. Karl held various leadership positions in Central and Western European markets. A strong leader, who has developed high performing teams to achieve ambitious financial targets, high level operational and performing standards and been accountable for around 1,600 employees."
        },
        {
          name: "Senthil Kumar RJ",
          role: "Director",
          photo: Senthil,
          bio: "Armed with a Master’s degree in Computer Applications, Senthil brings over 18 years of experience across Sales, Marketing, Product Management, and Operations. He has worked with clients in Africa, Asia Pacific, Europe, and the Middle East, successfully driving business growth in diverse markets. Senthil has collaborated with leading global brands, including Vodafone, Airtel, and Lycamobile Europe, leveraging his expertise to deliver impactful solutions across multiple regions."
        },
        {
          name: "Nagarathinam S",
          role: "Research and Development Head",
          photo: Rathinam,
          bio: "Nagarathinam, an M.Phil. graduate in Computer Science, oversees Research Projects and New Product Development in cutting-edge technologies at Sprout. Passionate about innovation, she is dedicated to discovering advanced tech frameworks to develop next-generation education solutions that reach learners in even the most remote areas of the country. A published author in international journals, Nagarathinam combines academic excellence with a forward-thinking approach to drive impactful educational advancements."
        },
        {
          name: "Poornima A",
          role: "Head HR & Operations",
          photo: Poornima,
          bio: "Poornima, a Postgraduate in Computer Science, oversees Recruitment, Employee Engagement, Internal Training, and overall operations at Sprout. She plays a crucial role in attracting and retaining talent, ensuring a dedicated workforce for the successful execution of Sprout’s programs in small towns and villages. Poornima’s leadership in employee happiness and development is key to maintaining operational excellence and driving Sprout’s mission forward."
        },

                {
          name: "K Manjamadevi",
          role: "Academic Head",
          photo: Manjamadevi,
          bio: "Manjamadevi, an experienced technology educator, leads training programs and curriculum development at Sprout Knowledge Solutions. Passionate about empowering learners, she focuses on delivering advanced programming, full-stack development, and AI-driven education solutions to students, professionals, and educators. With over 9+ years of teaching experience, Manjamadevi combines academic expertise with practical, hands-on learning approaches to prepare students for real-world technology challenges. She is dedicated to discovering innovative frameworks and tools to make technology education accessible, engaging, and impactful for learners across diverse backgrounds."
        },
              {
  name: "M Aparna",
  role: "Corporate Trainer",
  photo: Aparna,
  bio: "Aparna is a passionate and industry-focused technical educator with over 5+ years of teaching experience. She has successfully trained Indian and international learners through both online and offline modes. Her experience spans teaching college students and corporate professionals, enabling her to effectively bridge the gap between academic foundations and real-world industry requirements.\n\nShe specializes in Python, AI & Machine Learning, Data Science, Power BI, and Advanced Excel integrated with AI, with a strong emphasis on hands-on learning, real-time projects, and practical problem-solving. Known for her strong communication skills and friendly, learner-centric teaching style, she creates an engaging learning environment that builds confidence and clarity among learners.\n\nHer core focus is on industry readiness—helping learners apply concepts to real business scenarios, analytics use cases, and automation challenges. Aparna is committed to simplifying complex technical concepts and empowering learners to grow into skilled, job-ready professionals across diverse backgrounds."
},

{
  name: "Premchand",
  role: "Head – English SBU",
  photo: Premchand,
  bio: "Premchand heads the English Strategic Business Unit (SBU) and is responsible for the overall operations of this vertical. An MBA graduate with over 23+ years of experience, he has extensive expertise in Sales, Business Development, and Programme Execution.\n\nHe has proven strengths in Channel Management and is a seasoned B2B Solutions expert. Premchand has successfully led large-scale initiatives and partnerships across diverse markets.\n\nCurrently, he is focused on taking English Communication Skills to the farthest corners of the country, ensuring accessibility for students across all categories and empowering them with essential communication capabilities for academic and professional success."
}

      ];

  const PILLARS = [
    {
      id: 1,
      title: "Founders",
      color: "#38c7e8",
      text:
        "Seasoned entrepreneurs with a proven track record of success in education and technology sectors."
    },
    {
      id: 2,
      title: "Expertise",
      color: "#ef5a2a",
      text:
        "Deep understanding of the technology education ecosystem and evolving learner needs."
    },
    {
      id: 3,
      title: "Commitment",
      color: "#f5b71a",
      text:
        "Dedicated to delivering high-quality 4C skills to learners across semi-urban and rural regions."
    }
  ];

  return (
    <div className="ap-page">
      {/* =========================
          HERO
      ========================= */}
      <header
        className="about-hero"
        style={{ backgroundImage: `url(${heroImage})` }}
        role="img"
        aria-label="About Sprout"
      >
        <div className="about-hero-overlay" />
        <div className="about-hero-content" />

        <svg
          className="about-hero-wave"
          viewBox="0 0 1440 80"
          preserveAspectRatio="none"
          aria-hidden
        >
          <path
            d="M0,40 C360,120 1080,-40 1440,40 L1440,80 L0,80 Z"
            fill="#ffffff"
            opacity="0.98"
          />
        </svg>
      </header>

      {/* =========================
          MAIN CONTENT
      ========================= */}
      <main className="ap-container" aria-labelledby="about-heading">
        {/* INTRO */}
        <section className="ap-intro" id="about-heading">
          <div className="ap-intro-inner">
            <p>
              Sprout is an innovative Indo-European startup committed to equipping
              students and professionals with future-ready skills. By blending
              European pedagogical innovation with India’s cultural strengths, we
              deliver measurable learning outcomes in technology, communication,
              and problem-solving.
            </p>
          </div>
        </section>

        {/* =========================
            PILLARS
        ========================= */}
        <section className="ap-pillars" aria-label="Our strengths">
          {PILLARS.map((p) => (
            <article className="ap-pillar" key={p.id}>
              <div className="ap-pillar-left" style={{ "--ring-color": p.color }}>
                <div className="ap-number">{p.id}</div>

                <svg className="ap-pillar-ring" viewBox="0 0 260 260">
                  <circle cx="130" cy="130" r="98" className="ring-bg" />
                  <circle cx="130" cy="130" r="98" className="ring-arc" />
                </svg>

                <div className="ring-content">
                  <h4 className="ring-title" style={{ color: p.color }}>
                    {p.title}
                  </h4>
                  <p className="ring-text">{p.text}</p>
                </div>
              </div>

              {/* Accessibility fallback */}
              <div className="ap-pillar-content">
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </div>
            </article>
          ))}
        </section>

        {/* =========================
            TEAM
        ========================= */}
        <section className="ap-team" aria-labelledby="team-heading">
          <h2 id="team-heading">Team</h2>

          <div className="ap-team-grid">
            {TEAM_DATA.map((person, idx) => (
              <article
                className="ap-card"
                key={idx}
                onClick={() => setActiveMember(person)}
                role="button"
                tabIndex={0}
              >
                <div className="ap-card-image">
                  <img
                    src={person.photo}
                    alt={person.name}
                    loading="lazy"
                  />
                </div>

                <div className="ap-card-body">
                  <h4>{person.name}</h4>
                  <p className="ap-role">{person.role}</p>
                </div>

                <div className="ap-card-accent" />
              </article>
            ))}
          </div>
        </section>
      </main>

      {/* =========================
          TEAM MODAL
      ========================= */}
      {activeMember && (
        <div
          className="team-modal-overlay"
          onClick={() => setActiveMember(null)}
        >
          <div
            className="team-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="team-modal-header">
              <h3>{activeMember.name}</h3>
              <button
                className="team-modal-close"
                onClick={() => setActiveMember(null)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="team-modal-body">
              <p>{activeMember.bio}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


